import "../../assets/scss/components/templates/footer.scss";
import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import logo from "../../assets/images/logo.svg";
import fb from "../../assets/images/fb.svg";
import insg from "../../assets/images/insta.svg";
import tw from "../../assets/images/twitter.svg";
import ldn from "../../assets/images/linkedin.svg";
import email from "../../assets/images/email.svg";
import shape1 from "../../assets/images/home/footer-shape.svg";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <div className="footer">
      <Container>
        <Row className=" footer-section">
          <section>
            <Container className="text-start">
              <Row className="justify-content-between">
                <Col
                  lg={4}
                  xs={12}
                  className="mx-auto footer-logo mb-3 mb-lg-0"
                >
                  <a href="/" className="footer-heads ">
                    <Image src={logo} className="logo me-3" />
                  </a>
                  <br></br>
                  <br></br>
                  <div className="social-links d-flex align-items-center">
                    <div className="social me-3">
                      <a href="https://www.facebook.com/people/ResumlyAI/61572433467040/" target="_blank" rel="noopener noreferrer">
                        <Image src={fb} />
                      </a>
                    </div>
                    <div className="social me-3">
                      <a href="https://www.instagram.com/resumly.ai/" target="_blank" rel="noopener noreferrer">
                        <Image src={insg} />
                      </a>
                    </div>
                    <div className="social me-3">
                      <a href="https://x.com/ResumlyAI" target="_blank" rel="noopener noreferrer">
                        <Image src={tw} />
                      </a>
                    </div>
                    <div className="social me-3">
                      <a href="https://www.linkedin.com/company/resumlyai" target="_blank" rel="noopener noreferrer">
                        <Image src={ldn} />
                      </a>
                    </div>
                  </div>
                  <div className="copyright d-none d-lg-block">
                    <p>© 2025 Resumly.AI. All rights reserved.</p>
                  </div>
                </Col>

                <Col lg={3} xs={6} className="mx-auto mb-3 mb-lg-0">
                  <h1 className="footer-heads">Quick Links</h1>
                  <p className="footer-link">
                    <a href="/#pricing" onClick={(e) => {
                      if (window.location.pathname === '/') {
                        e.preventDefault();
                        document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>Pricing</a>
                  </p>
                  <p className="footer-link">
                    <a href="/#features" onClick={(e) => {
                      if (window.location.pathname === '/') {
                        e.preventDefault();
                        document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>Features</a>
                  </p>
                  <p className="footer-link">
                    <a href="/#how-it-works" onClick={(e) => {
                      if (window.location.pathname === '/') {
                        e.preventDefault();
                        document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>How it works</a>
                  </p>
                  <p className="footer-link">
                    <a href="/#examples" onClick={(e) => {
                      if (window.location.pathname === '/') {
                        e.preventDefault();
                        document.getElementById('examples').scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>Examples</a>
                  </p>
                </Col>

                <Col lg={2} xs={6} className="mx-auto mb-3 mb-lg-0">
                  <h1 className="footer-heads">Company</h1>
                  <p className="footer-link">
                    <a href="/#faq" onClick={(e) => {
                      if (window.location.pathname === '/') {
                        e.preventDefault();
                        document.getElementById('faq').scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>FAQ</a>
                  </p>
                  <p className="footer-link">
                    <a href="#!">Blog</a>
                  </p>
                  <p className="footer-link">
                    <a href="#!">Support</a>
                  </p>
                  <p className="footer-link">
                    <a href="#!">Affiliate Program</a>
                  </p>
                </Col>

                <Col lg={3} xs={12} className="mx-auto mb-3 mb-lg-0">
                  <div className="mb-4">
                    <h1 className="footer-heads">Legal</h1>
                    <p className="footer-link">
                      <a
                        onClick={() => {
                          navigate("/terms-and-conditions");
                          window.scrollTo(0, 0);
                        }}
                      >
                        Terms and Conditions
                      </a>
                    </p>
                    <p className="footer-link">
                      <a
                        onClick={() => {
                          navigate("/privacy-policy");
                          window.scrollTo(0, 0);
                        }}
                      >Privacy Policy</a>
                    </p>
                  </div>
                  <div className="d-none d-lg-block">
                    <h1 className="footer-heads">CONTACT US</h1>
                    <p className="footer-link">
                      <a
                        href="mailto:hello@resumly.ai"
                        className="cursor-pointer contact-us d-flex align-items-center"
                      >
                        <div className="icon">
                          <Image src={email} />
                        </div>
                        hello@resumly.ai
                      </a>
                    </p>
                  </div>
                </Col>

                <Col
                  lg={3}
                  xs={12}
                  className="mx-auto mb-3 mb-lg-0 d-lg-none d-block"
                >
                  <h1 className="footer-heads">CONTACT US</h1>
                  <p className="footer-link">
                    <a
                      href="mailto:hello@resumly.ai"
                      className="contact-us d-flex align-items-center"
                    >
                      <div className="icon">
                        <Image src={email} />
                      </div>
                      hello@resumly.ai
                    </a>
                  </p>
                </Col>

                <div className="copyright d-lg-none d-block">
                  <p>© 2025 Resumly.AI. All rights reserved.</p>
                </div>
              </Row>
            </Container>
          </section>
        </Row>
      </Container>
      {/*<div className="shape-1 shape">*/}
      {/*  <Image src={shape1} />*/}
      {/*</div>*/}
    </div>
  );
};

export default Footer;
